var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLiveText = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 38,
  height: 12,
  viewBox: "0 0 38 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1.40657 1.19963L0.174578 0.991629V-0.000366211H5.29455V0.991629L3.75856 1.19963V10.7516L7.18255 10.6076L8.19054 7.6156L9.48653 7.7916L8.99054 11.8876H0.142578V10.9276L1.40657 10.7676V1.19963Z",
  fill: "black"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.8016 1.19963L10.4417 0.991629V-0.000366211H15.5616V0.991629L14.1536 1.19963V10.7676L15.5616 10.9436V11.8876H10.4417V10.9276L11.8016 10.7676V1.19963Z",
  fill: "black"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M15.9958 -0.000366211H20.8597V0.991629L19.4997 1.19963L21.8837 8.36759L22.3477 9.98359L22.7477 8.35159L24.9877 1.19963L23.7237 0.991629V-0.000366211H27.5957V0.991629L26.5717 1.19963L22.8917 11.9996H20.9877L16.9557 1.19963L15.9958 0.991629V-0.000366211Z",
  fill: "black"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M29.1561 1.19963L27.8761 0.991629V-0.000366211H36.404L36.612 2.68762H35.492L34.964 1.10363L31.5081 0.959629V5.26361L33.732 5.21561L33.988 3.90362H35.012V7.7756H33.988L33.732 6.3996L31.5081 6.3516V10.8636L35.38 10.6716L36.308 8.62359L37.508 8.95959L37.092 11.8876H27.8921V10.9276L29.1561 10.7676V1.19963Z",
  fill: "black"
})));
export default SvgLiveText;